<template>
  <v-card class="overflow-hidden" outlined rounded="xl" :class="{ 'error-card': errorMessage }">
    <vs-text v-if="metadata" class="label" type="subdued">{{ metadataLabel }} </vs-text>
    <v-skeleton-loader v-if="loading" class="pa-4" type="list-item@3" />
    <ol v-if="stages" :class="{ 'pt-0': metadata }" class="stages pa-4">
      <pool-stage
        v-for="stage in stages"
        :key="stage.stage_definition_id"
        :stage="stage"
        @expired="onStageExpired"
      />
    </ol>
    <v-card-text v-if="errorMessage" class="error-message"
      ><vs-text type="warning">{{ errorMessage }} </vs-text></v-card-text
    >
  </v-card>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { PoolExecutionPlanMetadata, Stage } from '@/api/pools'
import PoolStage from '@/components/tickets/PoolStage.vue'

export default defineComponent({
  name: 'PoolStages',

  components: { PoolStage },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    stages: {
      type: Array as PropType<Stage[] | null>,
      default: () => [],
    },
    errorMessage: {
      type: String as PropType<string | null>,
      default: null,
    },
    metadata: {
      type: Object as PropType<PoolExecutionPlanMetadata | null>,
      default: null,
    },
  },

  setup(props, { emit }) {
    function onStageExpired(stageId) {
      emit('stage:expired', stageId)
    }

    const metadataLabel = computed(() => {
      if (props.metadata?.distance_miles) {
        return `~${props.metadata.distance_miles} miles`
      }
      return null
    })

    return {
      onStageExpired,
      metadataLabel,
    }
  },
})
</script>

<style scoped>
.stages {
  list-style: none;
  padding: 0;
  max-height: 17rem;
  overflow-x: auto;
}

.error-card {
  border-color: red;
  background-color: var(--color-red--lighter);
}

.error-message {
  color: red;
}

.label {
  margin: 0.5rem 0 0 1rem;
}
</style>
